

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { API_BASE_URL } from '../../config'; // Import the base URL
// Register chart elements and plugins
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const PieChart = () => {
  const [myRequestData, setMyRequestData] = useState(null);
  const [incomingRequestData, setIncomingRequestData] = useState(null);

  useEffect(() => {

    const fetchMyRequestData = async () => {
      try {
            const response = await axios.get(
              `${API_BASE_URL}/account/my-request-pie/`,
              {
                withCredentials: true,
              }
            );
        console.log('my request:', response.data);
        const { total_offered, total_pending, total_cancel, total_apply } =
          response.data;

        // Define initial labels and colors
        const labels = ['Offered', 'Pending', 'Cancelled'];
        const data = [total_offered, total_pending, total_cancel];
        const colors = ['#4CAF50', '#FFC107', '#F44336'];
        const hoverColors = ['#66BB6A', '#FFCA28', '#EF5350'];

        // Filter out items with a value of 0, preserving label, data, and color associations
        const filteredData = data
          .map((value, index) =>
            value > 0
              ? {
                  label: labels[index],
                  value,
                  color: colors[index],
                  hoverColor: hoverColors[index],
                }
              : null
          )
          .filter(item => item !== null);

        setMyRequestData({
          labels: filteredData.map(item => item.label),
          datasets: [
            {
              label: 'My Requests',
              data: filteredData.map(item => item.value),
              backgroundColor: filteredData.map(item => item.color),
              hoverBackgroundColor: filteredData.map(item => item.hoverColor),
            },
          ],
          total_apply, // Store total_apply in the state for displaying in the title
        });
      } catch (error) {
        console.error('Error fetching My Requests data:', error);
      }
    };

    const fetchIncomingRequestData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/incoming-request-pie/`,
          // 'https://finwise-backend.vercel.app/account/incoming-request-pie/',
          {
            withCredentials: true,
          }
        );
        console.log('incoming request:', response.data);
        const { total_offered, total_pending, total_cancel, total_loan } =
          response.data;

        const labels = ['Offered', 'Pending', 'Cancelled'];
        const data = [total_offered, total_pending, total_cancel];
        const colors = ['#4CAF50', '#FFC107', '#F44336'];
        const hoverColors = ['#66BB6A', '#FFCA28', '#EF5350'];

        const filteredData = data
          .map((value, index) =>
            value > 0
              ? {
                  label: labels[index],
                  value,
                  color: colors[index],
                  hoverColor: hoverColors[index],
                }
              : null
          )
          .filter(item => item !== null);

        setIncomingRequestData({
          labels: filteredData.map(item => item.label),
          datasets: [
            {
              label: 'Incoming Requests',
              data: filteredData.map(item => item.value),
              backgroundColor: filteredData.map(item => item.color),
              hoverBackgroundColor: filteredData.map(item => item.hoverColor),
            },
          ],
          total_loan, // Store total_loan in the state for displaying in the title
        });
      } catch (error) {
        console.error('Error fetching Incoming Requests data:', error);
      }
    };

    fetchMyRequestData();
    fetchIncomingRequestData();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        onHover: (event, legendItem) => {
          event.native.target.style.cursor = 'pointer';
        },
        onLeave: (event, legendItem) => {
          event.native.target.style.cursor = 'default';
        },
      },
      tooltip: {
        callbacks: {
          label: context => `${context.label}: ${context.raw}`,
        },
      },
      datalabels: {
        color: '#ffffff',
        formatter: value => value,
        align: 'end',
      },
    },
  };

  return (
    <div className="flex flex-col md:flex-row sm:flex-row gap-4 items-center justify-end">
      {/* My Request PieChart */}
      <div className="w-[95%] md:w-[20%] sm:w-[20%] border border-gray-300 p-2 rounded-lg shadow-md">
        <h3 className="text-center font-semibold mb-2 text-sm">
          My Request ({myRequestData?.total_apply || 0})
        </h3>
        {myRequestData ? (
          <Pie data={myRequestData} options={options} />
        ) : (
          <p>Loading My Request PieChart...</p>
        )}
      </div>

      {/* Incoming Request PieChart */}
      <div className="w-[95%] md:w-[20%] sm:w-[20%] border border-gray-300 p-2 rounded-lg shadow-md">
        <h3 className="text-center font-semibold mb-2 text-sm">
          Incoming Request ({incomingRequestData?.total_loan || 0})
        </h3>
        {incomingRequestData ? (
          <Pie data={incomingRequestData} options={options} />
        ) : (
          <p>Loading Incoming Request PieChart...</p>
        )}
      </div>
    </div>
  );
};

export default PieChart;






   // const fetchMyRequestData = async () => {
    //   try {
    //     const response = await axios.get(
    //       'http://127.0.0.1:8000/account/my-request-pie/',
    //       {
    //         // headers: {
    //         //   Cookie:
    //         //     'csrftoken=aNDEX8Hh9fBH9lwYAuuu2NoVREw0SYio; sessionid=b8tgjifnsbbwc1bpxwsqgqf1hnswfsml',
    //         // },
    //         withCredentials: true,
    //       }
    //     );
    //     console.log("my request:", response.data)
    //     const { total_offered, total_pending, total_cancel, total_apply } =
    //       response.data;

    //     setMyRequestData({
    //       labels: ['Offered', 'Pending', 'Cancelled'],
    //       datasets: [
    //         {
    //           label: 'My Requests',
    //           data: [total_offered, total_pending, total_cancel],
    //           backgroundColor: ['#4CAF50', '#FFC107', '#F44336'],
    //           hoverBackgroundColor: ['#66BB6A', '#FFCA28', '#EF5350'],
    //         },
    //       ],
    //       total_apply, // Store total_apply in the state for displaying in the title
    //     });
    //   } catch (error) {
    //     console.error('Error fetching My Requests data:', error);
    //   }
    // };

    // const fetchIncomingRequestData = async () => {
    //   try {
    //     const response = await axios.get(
    //       'http://127.0.0.1:8000/account/incoming-request-pie/',
    //       {
    //         // headers: {
    //         //   Cookie:
    //         //     'csrftoken=aNDEX8Hh9fBH9lwYAuuu2NoVREw0SYio; sessionid=b8tgjifnsbbwc1bpxwsqgqf1hnswfsml',
    //         // },
    //         withCredentials: true,
    //       }
    //     );
    //     console.log('incomming request:', response.data);
    //     const { total_offered, total_pending, total_cancel, total_loan } =
    //       response.data;

    //     setIncomingRequestData({
    //       labels: ['Offered', 'Pending', 'Cancelled'],
    //       datasets: [
    //         {
    //           label: 'Incoming Requests',
    //           data: [total_offered, total_pending, total_cancel],
    //           backgroundColor: ['#4CAF50', '#FFC107', '#F44336'],
    //           hoverBackgroundColor: ['#66BB6A', '#FFCA28', '#EF5350'],
    //         },
    //       ],
    //       total_loan, // Store total_loan in the state for displaying in the title
    //     });
    //   } catch (error) {
    //     console.error('Error fetching Incoming Requests data:', error);
    //   }
    // };


